// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * 認証が必要なルート用のガードコンポーネント
 * ログインしていない場合は /login にリダイレクト
 */
function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  // 認証状態の読み込み中
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // 未ログインの場合はログイン画面へリダイレクト
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 認証済みの場合は子コンポーネントを表示
  return children;
}

export default PrivateRoute;
